import { Injectable } from "@angular/core";
import { AlertController, LoadingController } from "@ionic/angular";

declare var Email;

@Injectable({
  providedIn: "root",
})
export class UtilsService {
  constructor(
    private load: LoadingController,
    private alert: AlertController
  ) {}

  async doLoading() {
    await this.load
      .create({
        message: "Carregando...",
        spinner: "bubbles",
        translucent: true,
        mode: "ios",
      })
      .then((loader) => loader.present());
  }

  async doDismissLoading() {
    await this.load.dismiss();
  }

  async doAlert(_header, _message) {
    await this.alert
      .create({
        header: _header ? _header : "Aviso",
        message: _message,
        buttons: ["Ok"],
      })
      .then((alerta) => alerta.present());
  }

  async doDismissAlert() {
    await this.alert.dismiss();
  }

  sendEmail(to: string, from: string, subject: string, body: string) {
    Email.send({
      Host: "smtp.elasticemail.com",
      Username: "cpaixaoneto@gmail.com",
      Password: "FD74D56E716E83E7049FB4B6EA8485C8569",
      To: to,
      From: from,
      Subject: subject,
      Body: body,
    }).then((message) => {
      console.log(message);
    });
  }

  converteDataParaFormatoIso(dataString) {
    // Primeiro, dividimos a data completa em duas partes:
    const [date, time] = dataString.split(" ");

    // Dividimos a data em dia, mês e ano:
    const [DD, MM, YYYY] = date.split("/");

    // Dividimos o tempo em hora e minutos:
    const [HH, mm] = time.split(":");

    // Retornamos a data formatada em um padrão compatível com ISO:
    return `${YYYY}-${MM}-${DD}T${HH}:${mm}`;
  }

  isCpfComplete(cpf: string): boolean {
    return cpf && cpf.length === 14;
  }
}
